import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

// Pages
import HomePage from "./pages/HomePage";
import DestinationsPage from "./pages/DestinationsPage";
import CityPage from "./pages/CityPage";
import AboutPage from "./pages/AboutPage";
import FAQPage from "./pages/FAQPage";
import LogoShowcase from "./pages/LogoShowcase";
import HowItWorksPage from "./pages/HowItWorksPage";

function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/destinations" element={<DestinationsPage />} />
          <Route path="/city/:slug" element={<CityPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/logo-options" element={<LogoShowcase />} />
          <Route path="/thanks" element={<PaymentSuccessPage />} />
          {/* Catch-all route */}
          <Route path="*" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
